import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ConfigEntityService } from "../../../../core/services/config-entity.service";
import { NavigationService } from "../../../../core/services/navigation.service";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { MatDialog } from "@angular/material/dialog";
import { FormControl, FormGroup } from "@angular/forms";
import {
  ConfigParameter,
  SyncHpcConfig,
} from "../../../../core/models/config-entities";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SaveDeploymentSettingsComponent } from "src/app/modules/deployment/modals/save-deployment-settings/save-deployment-settings.component";
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from "rxjs";
import { ConfigSectionComponent } from "src/app/modules/pages/config-section/config-section.component";
import { ServiceBroadcastComponent } from "src/app/modules/pages/configurator/service-broadcast/service-broadcast.component";
import { UpdateAuthenticationConfigurationComponent } from "src/app/modules/pages/configurator/update-authentication-configuration/update-authentication-configuration.component";
import { UpdateLoginUiConfiguratorComponent } from "src/app/modules/pages/configurator/update-login-ui-configurator/update-login-ui-configurator.component";
import { Router } from "@angular/router";
import { UserRoleNames } from "src/app/core/models/users";
import { SyncConfigService } from "../../../../core/services/sync-config.service";

@Component({
  selector: "app-synchpc-configure",
  templateUrl: "./synchpc-configure.component.html",
  styleUrls: ["./synchpc-configure.component.scss"],
})
export class SynchpcConfigureComponent implements OnInit, OnDestroy {
  toShow: boolean;
  activeEntity: any;
  isSendingEmail = false;
  activeChild: string = "";
  configParameters: ConfigParameter[];
  filteredParameters: ConfigParameter[];
  filteredConfigParameters: ConfigParameter[];
  syncHpcConfigForm: FormGroup;
  fieldTextType: boolean = true;
  searchTerm: FormControl = new FormControl("");
  destroySub$ = new Subject();
  search = new FormControl("");
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;

  @ViewChild("configComp") configSection: ConfigSectionComponent;

  constructor(
    private configEntityService: ConfigEntityService,
    private navService: NavigationService,
    private spiner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog,
    private router: Router,
    private syncConfig: SyncConfigService
  ) {}

  ngOnInit(): void {
    this.toShow = false;
    this.spiner.show();
    this.navService.breadcrumbDeployment.subscribe(
      (x) => (this.activeChild = x)
    );
    this.navService.breadcrumbActiveProperty.subscribe(
      (x) => (this.activeEntity = x)
    );

    this.syncHpcConfigForm = new FormGroup({});

    this.searchTerm.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this.destroySub$)
      )
      .subscribe((val: string) => {
        this.filterParameter(val.toLowerCase());
      });
    this.loadData();
    this.configEntityService.sendActiveEntity("SyncHPC Settings");
    this.navService.sendChildData("SyncHPC Settings");
  }

  ngOnDestroy() {
    this.destroySub$.next(null);
    this.destroySub$.complete();
  }

  loadData() {
    this.configEntityService.getSyncHPCConfig().subscribe((data) => {
      this.configParameters = <ConfigParameter[]>(
        JSON.parse(JSON.stringify(data))
      );
      this.filteredParameters = this.configParameters;
      this.filteredConfigParameters = <ConfigParameter[]>(
        JSON.parse(JSON.stringify(data))
      );
      this.configParameters.forEach((param) => {
        this.syncHpcConfigForm.addControl(
          param.parameterName,
          new FormControl(param.parameterValue)
        );
      });
      if (
        localStorage.getItem("LicenseExpired") &&
        localStorage.getItem("LicenseExpired") == "true"
      ) {
        this.configParameters = this.configParameters.filter(
          (x) => x.parameterName == "LicenseKey"
        );
        this.authenticationService.showLicenseExpireSnackbar(
          "License Expired. Please update license key."
        );
      }
    });
  }

  filterParameter(searchTerm: string) {
    if (!searchTerm) {
      this.filteredParameters = this.configParameters;
    } else {
      this.filteredParameters = this.configParameters.filter(
        (param) =>
          param.parameterDisplayName.toLowerCase().includes(searchTerm) ||
          param.parameterSection.toLowerCase().includes(searchTerm)
      );
    }
    this.configSection.configEntities = this.filteredParameters;
    this.configSection.sectionedConfigEntities = {};
    this.configSection.handleConfigEntitiesOperation();
  }

  onSave() {
    const isValid = this.configSection.checkIfFormValid();
    if (!isValid) {
      this.snackBar.open("Please enter valid values.", "Ok", {
        duration: 5000,
      });
      return;
    }
    let updatedValues: ConfigParameter[] | [] = this.configSection.getValues();
    if (!updatedValues || updatedValues.length == 0) {
      this.snackBar.open("No changes to save.", "Ok", {
        duration: 3000,
      });
      return;
    }
    let dialogRef = this.dialog.open(SaveDeploymentSettingsComponent, {
      disableClose: true,
      width: "400px",
      data: {
        title: "Save Changes",
        message: "Do you want to save applied changes ?",
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        let syncHpcConfig: SyncHpcConfig = new SyncHpcConfig(updatedValues);
        this.configEntityService.updateSyncHPCConfig(syncHpcConfig).subscribe({
          next: (data) => {
            this.checkLicenseExpiry();
          },
          error: (err) => {
            if (err.error.actionMessage) {
              this.snackBar.open(err.error.actionMessage, "Ok", {
                duration: 5000,
              });
            }
          },
        });
      }
    });
  }

  checkLicenseExpiry() {
    if (
      localStorage.getItem("LicenseExpired") &&
      localStorage.getItem("LicenseExpired") == "true"
    ) {
      let isLoginEnabled: boolean = false;

      this.configEntityService.checkIfLoginEnabled().subscribe((data) => {
        isLoginEnabled = <any>data;
        if (isLoginEnabled === true) {
          localStorage.removeItem("LicenseExpired");
          this.authenticationService.closeLicenseExpireSnackbar();
          let _snack = this.snackBar.open("License Key updated", "OK", {
            duration: 5000,
          });
          _snack.afterDismissed().subscribe((data) => location.reload());
        } else {
          localStorage.setItem("LicenseExpired", "true");
          this.authenticationService.closeLicenseExpireSnackbar();
          this.authenticationService.showLicenseExpireSnackbar(
            "Invalid License key."
          );
        }
      });
    } else {
      this.snackBar.open("Settings has been Updated Successfully.", "Ok", {
        duration: 3000,
      });
      window.location.reload();
    }
  }

  onReset() {
    let dialogRef = this.dialog.open(SaveDeploymentSettingsComponent, {
      disableClose: true,
      width: "400px",
      data: {
        title: "Reset",
        message: "Do you want to reset the changes ?",
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.loadData();
      }
    });
  }

  togglePasswordIcon() {
    this.fieldTextType = !this.fieldTextType;
  }

  updateAuthenticationConfiguration() {
    const dialogRef = this.dialog.open(
      UpdateAuthenticationConfigurationComponent,
      {
        width: "60%",
        autoFocus: true,
        disableClose: false,
      }
    );
    dialogRef.afterClosed().subscribe((res) => {
      this.refreshComponent();
    });
  }

  updateLogInPageUIConfiguration() {
    const dialogRef = this.dialog.open(UpdateLoginUiConfiguratorComponent, {
      width: "60%",
      autoFocus: true,
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        window.location.reload();
      }
    });
  }

  addServiceBroadcastMessage() {
    const dialogRef = this.dialog.open(ServiceBroadcastComponent, {
      width: "40%",
      autoFocus: true,
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        //window.location.reload();
        this.snackBar.open(res, "OK", { duration: 3000 });
      }
    });
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  onSendTestEmailClick(): void {
    const notificationEmail =
      this.syncHpcConfigForm.get("NotificationEmail")?.value;
    const smtpHost = this.syncHpcConfigForm.get("SmtpHost")?.value;
    const smtpPort = this.syncHpcConfigForm.get("SmtpPort")?.value;

    if (!notificationEmail || !smtpHost || !smtpPort) {
      this.snackBar.open("Please configure email settings first", "Close", {
        duration: 3000,
      });
      return;
    }
    this.sendTestEmail();
  }

  private sendTestEmail(): void {
    this.isSendingEmail = true; // Show animation

    this.syncConfig.sendTestEmail().subscribe({
      next: (response) => {
        this.isSendingEmail = false; // Hide animation

        if (response != null) {
          const result = response["message"]["result"];
          if (result["success"]) {
            this.snackBar.open(result["message"], "Close", { duration: 3000 });
          } else {
            const errorMessage =
              result["message"] || "Failed to send test email";
            this.snackBar.open(result["message"], "Close", { duration: 5000 });
          }
        } else {
          this.snackBar.open("Failed to send test email", "Close", {
            duration: 5000,
          });
        }
      },
      error: (err) => {
        this.isSendingEmail = false; // Hide animation
        this.snackBar.open("Failed to connect to email service", "Close", {
          duration: 5000,
        });
      },
    });
  }
}
